import { Button, Dialog, Icon, Tooltip } from '@startlibs/components';
import { formatDate, getColor } from '@startlibs/utils';
import React from 'react'
import _ from 'lodash/fp'
import styled, { css } from 'styled-components';

import { RecordStatus } from './lib/utils/recordEnums';
import {useUploadLog} from './lib/service/uploadLog'

export const UploadLogDialog = ({closeDialog, filter = _.identity, title = "Upload log"}) => {

  const [uploadLog] = useUploadLog()
  const filteredLog = filter(uploadLog)

  return <Dialog
    closeDialog={closeDialog}
    title={title}
    css="max-width:54rem;"
    footer={<Button highlight onClick={closeDialog}>Close</Button>}
  >
    <UploadLodTableWrapper>
    <UploadLodTable>
        <TableRow header>
          <div className="cell timestamp">Time</div>
          <div className="cell details">File</div>
          <div className="cell state">Status</div>
        </TableRow>
        {
          filteredLog.map(item => 
            <TableRow failed={item.status === RecordStatus.Failed}>
              <div className="cell timestamp">{formatDate(new Date(item.date),"MM/dd/yyyy - hh:mm")}</div>
              <div className="cell details"><span className="file-name">{item.file.name}</span></div>
              {item.errorMessage && item.errorMessage.length > 0 
                ? <div className="cell state">
                    <Tooltip content={item.errorMessage} position="top">{item.status === RecordStatus.Failed && <Icon icon="warning" />}{item.status}</Tooltip>
                  </div>
                : <div className="cell state">{item.status === RecordStatus.Failed && <Icon icon="warning" />}{item.status}</div>
              }
            </TableRow>
          )
        }
    </UploadLodTable>
    </UploadLodTableWrapper>
  </Dialog>
}

const UploadLodTableWrapper = styled.div`
  border: 1px solid rgb(220,220,220);
  border-radius: 6px;
  overflow: hidden;
`
  
const UploadLodTable = styled.div`
  max-height: 30rem;
  max-height: 65vh;
  min-height: 20rem;
  overflow: auto;
`

const TableRow = styled.div `
  width: 100%;
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid rgb(230,230,230);
  :last-child {
    border-bottom: none;
  }
  .timestamp {
    flex-basis: 120px;
    flex-shrink: 0;
  }
  .details {
    flex-grow: 1;
    margin: 0 2rem;
    font-weight: 600;
  }
  .state {
    flex-shrink: 0;
    flex-basis: 130px;
    display: inline-flex;
    align-items: center;
    ${Icon} {
      font-size: 14px;
      margin-right: .5rem;
    }
  }
  ${props => props.header && css`
    position: sticky;
    top: 0;
    font-weight: bold;
    background: white;
    border-bottom: 1px solid rgb(220,220,220);
  `}
  ${props => props.failed && css`
    .state {
      color: ${getColor('alert')};
    }
  `}
`